// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"538":"26244b67","628":"0ad29220","722":"87d91dc9"}[chunkId] + ".chunk.css";
};